import { render } from "./SubidasFidu.vue?vue&type=template&id=664f7c68"
import script from "./SubidasFidu.vue?vue&type=script&lang=js"
export * from "./SubidasFidu.vue?vue&type=script&lang=js"

import "./SubidasFidu.vue?vue&type=style&index=0&id=664f7c68&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__